var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.getters.isAuthenticated)?_c('WelcomeView'):_c('v-container',{staticClass:"home pa-6"},[_c('job-number-search',{ref:"input-field",on:{"jobObjectSelected":_vm.selectedJobNumber}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }